import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const LoginChoice = () => {
  const navigate = useNavigate();

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src={BXILOGO} alt="BXI" />
        </div>
        <h1>Admin Login</h1>
        <p className="login-subtitle">
          Choose which admin portal to sign in to.
        </p>

        <button
          type="button"
          className="login-choice-card"
          onClick={() => navigate('/login/bxi')}
        >
          <p className="choice-title">BXI Admin</p>
          <p className="choice-desc">Company onboarding & membership only</p>
        </button>
        <button
          type="button"
          className="login-choice-card"
          onClick={() => navigate('/login/brand-world')}
        >
          <p className="choice-title">Brand World Admin</p>
          <p className="choice-desc">Orders, wallet, inventory, transactions</p>
        </button>
      </div>
    </div>
  );
};

export default LoginChoice;


const BXILOGO = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/BXI_LOGO.png';
